import { useMutation, MutateOptions } from "@tanstack/react-query";
import { SoloFileMapParams } from "shared";
import { useSoloStore } from "../contexts/soloConfig";

export const useSoloFileMap = (opts?: MutateOptions<any, any, any>) => {
  const patch = useSoloStore((store) => store.files.mapFile);

  return useMutation({
    mutationFn: async (params: { id: string; data: SoloFileMapParams }) => patch(params.id, params.data),
    ...(opts || {}),
  });
};
